/* global axios */

import ApiClient from './ApiClient';

const serialize = flow => {
  const payload = { ...flow };
  if (payload.flow_json && typeof payload.flow_json !== 'string') {
    payload.flow_json = JSON.stringify(payload.flow_json);
  }
  if (payload.builder && typeof payload.builder !== 'string') {
    payload.builder = JSON.stringify(payload.builder);
  }
  return { whatsapp_flow: payload };
};

class WhatsappFlowsAPI extends ApiClient {
  constructor() {
    super('whatsapp_flows', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  createFlow(flow) {
    return axios.post(this.url, serialize(flow));
  }

  updateFlow(id, flow) {
    return axios.patch(`${this.url}/${id}`, serialize(flow));
  }

  refresh(id) {
    return axios.post(`${this.url}/${id}/refresh`);
  }

  publish(id) {
    return axios.post(`${this.url}/${id}/publish`);
  }

  deprecate(id) {
    return axios.post(`${this.url}/${id}/deprecate`);
  }

  sync(inboxId) {
    return axios.post(`${this.url}/sync`, { inbox_id: inboxId });
  }
}

export default new WhatsappFlowsAPI();
